// provides demonstration data for front-end while developing back end

const demoAbilities = () => Promise.resolve(demoAbilitiesData);
const demoAbilitiesData = [
  {
      role: 'Firefighter',
      account: 'Insights Product',
      dual: true
  },
  {
      role: 'Firefighter',
      account: 'Finance Area Product',
      dual: true,
      credentials: {
          type: "AWS",
          expires: "2018-05-29T12:15:39.3Z",
          renewable: true,
          value: {
              "AWS_ACCESS_KEY_ID":"AXDWSDSJIWLKJFAS",
              "AWS_SECRET_ACCESS_KEY":"djqeitoha/eowafawoieja/jeiw",
              "AWS_SESSION_TOKEN":"wfefojg^==$saf&&&%ajqowiejfsdf232930askgja;wli4;lkja",
              consoleUrl: "https://console.amazonaws.com/2952109223410/?session=23101119&role=Firefighter-298310211"
          }
      }
  },
  {
      role: 'Firefighter',
      account: 'CAS Product',
      dual: true
  },
  {
    role: 'Developer',
    account: 'Insights Developers'
  },
  {
    role: 'Developer',
    account: 'Insights Product'
  },
  {
    role: 'Developer',
    account: 'Automation Developers'
  },
  {
    role: 'Developer',
    account: 'Finance Product'
  },
  {
    role: 'Developer',
    account: 'Lambda Developers'
  },
  {
    role: 'Emergency',
    account: 'CAS Product'
  }

]

export {demoAbilities};



// WEBPACK FOOTER //
// ./src/abilities/demoWiring.js